/* eslint-disable sort-keys */
import { CFTokens } from '../../../../tokens';
export const TYPE_SPECS = {
    xs: CFTokens.TYPE_SPEC_SCALE.D_BOLD_AUTO,
    sm: CFTokens.TYPE_SPEC_SCALE.E_BOLD_AUTO,
    md: CFTokens.TYPE_SPEC_SCALE.F_BOLD_AUTO,
    lg: CFTokens.TYPE_SPEC_SCALE.G_BOLD_AUTO,
    xl: CFTokens.TYPE_SPEC_SCALE.H_BOLD_AUTO,
};
